import AppDispatcher from "../dispatcher/AppDispatcher";
import constants from "../constants/TagConstants";
import { EventEmitter } from "events";
import TagAPI from "../utils/TagAPI";
import TagActions from "../actions/TagActions";
import EspHealthActions from "../actions/EspHealthActions";

const CHANGE_EVENT = "CHANGE";
let _tags = [];
let _tag = {};
let _stateTags=[];
let _errorMessage = "";
let _status = false;
let _notify = false;
let _notifyMsg = "";
let _isLoading = false;

class TagStore extends EventEmitter {
  constructor() {
    super();
    AppDispatcher.register(this._registerToActions.bind(this));
  }

  _registerToActions(payload) {
    try {
      const action = payload.action;
      switch (action.type) {
        case constants.LOAD_ALL_TAGS_REQUEST:
          _isLoading = true;
          TagAPI.getAllTags();
          this.emitChange();
          break;
        case constants.LOAD_ALL_TAGS:
          if (action.tags === "Failed to fetch") {
            _errorMessage = "fieldToFetch";
            _status = true;
            _isLoading = false;
          } else {
            _tags = action.tags.data;
            _isLoading = false;
          }
          this.emitChange();
          break;

        case constants.LOAD_TAG_REQUEST:
          _isLoading = true;
          TagAPI.loadTag(action.tagKey);
          this.emitChange();
          break;
        case constants.LOAD_TAG:
          if (action.tag === "Failed to fetch") {
            _errorMessage = "fieldToFetch";
            _status = true;
            _isLoading = false;
          } else {
            _isLoading = false;
            _tag = action.tag.data;
          }
          this.emitChange();
          break;

        case constants.ADD_TAG:
          _isLoading = true;
          this.insertTag(action.tag,action.isOutputTag);
          this.emitChange();
          break;
        case constants.UPDATE_TAG:
          _isLoading = true;
          this.updateTag(action.tag);
          this.emitChange();
          break;
        case constants.DELETE_TAG:
          _isLoading = true;
          this.deleteTag(action.TagKey);
          this.emitChange();
          break;

        case constants.LOAD_ALL_STATE_TAGS_REQUEST:
          _isLoading = true;
          TagAPI.getAllStateTags();
          this.emitChange();
          break;
        case constants.LOAD_ALL_STATE_TAGS:
          if (action.tags === "Failed to fetch") {
            _errorMessage = "fieldToFetch";
            _status = true;
            _isLoading = false;
          } else {
            _stateTags = this.prepareStateTags(action.tags.data);
            _isLoading = false;
          }
          this.emitChange();
          break;
        case constants.ADD_STATE_TAG:
          _isLoading = true;
          this.insertStateTag(action.tag);
          this.emitChange();
          break;
        case constants.UPDATE_STATE_TAG:
          _isLoading = true;
          this.updateStateTag(action.tag);
          this.emitChange();
          break;
          case constants.DELETE_STATES:
            _isLoading = true;
            this.deleteStateTag(action.TagKey);
            this.emitChange();
            break;
        default:
          return "";
      }
      return true;
    } catch (e) {
      console.log("_registerToActions function in TagStore ", e);
    }
  }

  emitChange() {
    this.emit(CHANGE_EVENT);
  }

  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  }

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  }

  getIsLoading() {
    return _isLoading;
  }

  getNotify() {
    return _notify;
  }

  getNotifyMsg() {
    return _notifyMsg;
  }

  setNotify() {
    _notify = false;
    _notifyMsg = "";
  }

  setIsLoading() {
    _isLoading = false;
  }

  getAllTags() {
    return _tags;
  }

  getTag() {
    return _tag;
  }

  getAllStateTags(){
    let stateTags=_stateTags;
    try {
      stateTags=_stateTags.sort((a,b)=>(b.TagKey-a.TagKey))
    } catch (e) {
      console.log(e);
    }
    return _stateTags;
  }

  getStatus() {
    return _status;
  }

  errorMessage() {
    return _errorMessage;
  }

  setStatus() {
    _status = "";
  }

  insertTag(tag,isOutputTag) {
    TagAPI.addTag(tag)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _isLoading = false;
              _status = true;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _isLoading = false;
              _notifyMsg = "NameExist";
              _notify = true;
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "success";
              _notify = true;
              // console.log({response});
              if(isOutputTag){
                EspHealthActions.setCreatedTagID(response.data.TagKey);
              }
              TagActions.loadAllTagsRequest();
              this.emitChange();
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("insertTag function in TagStore ", e);
      });
  }

  updateTag(tag) {
    TagAPI.updateTag(tag)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _status = true;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _status = true;
              _errorMessage = "NameExist";
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "updated";
              _notify = true;
              TagActions.loadTagRequest(tag.TagKey);
              TagActions.loadAllTagsRequest();
              this.emitChange();
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("updateTag function in TagStore ", e);
      });
  }

  insertStateTag(tag) {
    TagAPI.addStateTag(tag)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _isLoading = false;
              _status = true;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _isLoading = false;
              _notifyMsg = "NameExist";
              _notify = true;
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "success";
              _notify = true;
              TagActions.loadAllStateTagsRequest();
              this.emitChange();
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("insertTag function in TagStore ", e);
      });
  }

  updateStateTag(tag) {
    TagAPI.updateTag(tag)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _status = true;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _status = true;
              _errorMessage = "NameExist";
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "updated";
              _notify = true;
              // TagActions.loadTagRequest(tag.TagKey);
              TagAPI.updateStates(tag.TagKey,tag.AllStates).then((response)=>{
                TagActions.loadAllStateTagsRequest();
                this.emitChange();
              })
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("updateTag function in TagStore ", e);
      });
  }

  get(tagKey) {
    try {
      const index = _tags.findIndex((tag) => {
        return tag.tagKey === tagKey;
      });
      return _tags[index];
    } catch (e) {
      console.log("get function in TagStore");
    }
  }

  getMlTags() {
    try {
      return _tags.filter((tag) => tag.TagName.substr(0, 3) === "ML_");
    } catch (e) {
      console.log(e);
    }
  }

  getHITags() {
    try {
      return _tags.filter((tag) => tag.TagName.substr(0, 3) === "HI_");
    } catch (e) {
      console.log(e);
    }
  }

  deleteTag(TagKey) {
    TagAPI.deleteTag(TagKey)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _status = true;
              _isLoading = false;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _notify = true;
              _notifyMsg = "unableDelete";
              _isLoading = false;
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "deleted";
              _notify = true;
              TagActions.loadAllTagsRequest();
              this.emitChange();
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("deleteTag function in TagStore ", e);
      });
  }

  deleteStateTag(TagKey) {
    TagAPI.deleteTag(TagKey)
      .then((response) => {
        if (response.message === "Failed to fetch") {
          _errorMessage = "fieldToFetch";
          _status = true;
          _isLoading = false;
          this.emitChange();
        } else {
          switch (parseInt(response.code, 10)) {
            case 0:
              _status = true;
              _isLoading = false;
              _errorMessage = "sessionExpired";
              this.emitChange();
              break;
            case 1:
              _notify = true;
              _notifyMsg = "unableDelete";
              _isLoading = false;
              this.emitChange();
              break;
            case 2:
              _isLoading = false;
              _notifyMsg = "deleted";
              _notify = true;
              TagAPI.updateStates(TagKey,"[]")
              TagActions.loadAllStateTagsRequest();
              this.emitChange();
              break;
            default:
              break;
          }
        }
      })
      .catch((e) => {
        console.log("deleteTag function in TagStore ", e);
      });
  }


  prepareStateTags(data) {
    let tags = [];
    try {
      data.forEach((d) => {
        d.TagStates = d.AllStates !== undefined ? d.AllStates.map((st) => {
          return {
            StateValue: st[0],
            StateName: st[1],
            StateDispName: st[2],
          };
        }) : []
        tags.push(d)
      });
    } catch (e) {
      console.log(e);
    }
    return tags;
  }
}

export default new TagStore();
